import React, { useState, useEffect } from "react";
import DataService from "../../../services/data.service";

import "./AddRowStatusBar.css";

export default props => {
  let [editing, setEditing] = useState(false);

  useEffect(() => {
    props.api.addEventListener("rowEditingStarted", onRowEditingStarted);
    props.api.addEventListener("rowEditingStopped", onRowEditingStopped);

    return () => {
      props.api.removeEventListener("rowEditingStarted", onRowEditingStarted);
      props.api.removeEventListener("rowEditingStopped", onRowEditingStopped);
    };
  }, []);

  function onRowEditingStarted() {
    setEditing(true);
  }

  function onRowEditingStopped() {
    setEditing(false);
  }

  function addRow() {
    let id;
    let emptyRow = { id };
    props.api.updateRowData({ add: [emptyRow] });
    let node = props.api.getRowNode(id);
    props.api.ensureIndexVisible(node.rowIndex);

    console.log('debug', node)

    setTimeout(() => {
      props.api.startEditingCell({
        rowIndex: node.rowIndex,
        colKey: props.columnApi.getAllColumns()[0].colId
      });
    }, 300);
  }

  function update() {
    DataService.updateAll()
    .then(result => (console.log(result.status)))
  }

  return (
    <div className="add-btn-container">
      <button
        variant={editing ? "outlined" : "contained"}
        color="primary"
        onClick={addRow}
        disabled={editing}
      >
        Add Row
      </button>
      <button
        variant={editing ? "outlined" : "contained"}
        color="primary"
        onClick={update}
        disabled={editing}
      >
        Update
      </button>
    </div>
  );
};
